import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { EffectsModule } from "@ngrx/effects";
import { TranslateModule } from "@ngx-translate/core";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { GlobalModule } from "@obg/ngx.global";

import { LimitsReminderDialogContainer } from "./dialog/limits-reminder-dialog.container";
import { LimitsReminderComponent } from "./limits-reminder/limits-reminder.component";
import { LimitsReminderEffect } from "./sdk/limits-reminder.effect";

const COMPONENTS = [LimitsReminderDialogContainer, LimitsReminderComponent];

@NgModule({
	imports: [
		CommonModule,
		CoreModule,
		GlobalModule,
		DialogLayoutModule,
		MatButtonModule,
		TranslateModule,
		EffectsModule.forFeature([LimitsReminderEffect]),
	],
	declarations: [...COMPONENTS],
	exports: [...COMPONENTS],
})
export class MatCommonLimitsReminderModule {}
